import { getPosthog, initPosthog } from '@/Common/Posthog.js';

export default {
  install(app) {
    void initPosthog();

    app.config.globalProperties.$posthog = {
      capture: (...args) => getPosthog()?.capture(...args),
      identify: (...args) => getPosthog()?.identify(...args)
    };
  }
};
